var $768ecc7892c5a9a9$exports = {};
$768ecc7892c5a9a9$exports = {
    "collapse": `\u{5DB}\u{5D5}\u{5D5}\u{5E5}`,
    "expand": `\u{5D4}\u{5E8}\u{5D7}\u{5D1}`
};


export {$768ecc7892c5a9a9$exports as default};
//# sourceMappingURL=he-IL.mjs.map
